module.exports = __webpack_public_path__ + "files/b0d0ad99214c4723703614b6c6723e33.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/redfavicon-16x16.png
// module id = 2376
// module chunks = 0